import type {
    GetStandalonePackageDownloadRequest,
    GetStandalonePackageDownloadResponse,
    InsightOutputFormat,
} from "@amzn/d16-g-client-deck-builder-typescript-client";
import type { AsyncState, UseAsyncActions } from "@react-hookz/web";
import { useAsync } from "@react-hookz/web";

import { getCdbApiClient } from "../../api/cdbApi/cdbApi";
import { useAsyncErrorStatusNotification } from "../notifications/useAsyncErrorStatusNotification";

export interface StandalonePackagePreviewDownloadActionProps {
    advertiserIdType: string;
    advertiserId: string;
    marketplaceId: string;
    identifier: string;
    outputFormat: InsightOutputFormat;
}

export function useInsightPackagePreviewDownloadAction({
    advertiserIdType,
    advertiserId,
    marketplaceId,
    identifier,
    outputFormat,
}: StandalonePackagePreviewDownloadActionProps): [
    AsyncState<GetStandalonePackageDownloadResponse | undefined>,
    UseAsyncActions<GetStandalonePackageDownloadResponse>,
] {
    const getStandalonePackageDownloadRequest: GetStandalonePackageDownloadRequest =
        {
            advertiserIdType,
            advertiserId,
            marketplaceId,
            packageInstanceId: identifier,
            outputFormat,
        };

    const [previewDownloadState, previewDownloadAction] = useAsync(async () => {
        return await (
            await getCdbApiClient()
        ).getStandalonePackageDownload(getStandalonePackageDownloadRequest);
    });

    useAsyncErrorStatusNotification(previewDownloadState);
    return [previewDownloadState, previewDownloadAction];
}
